import { useState } from "react";
import Reveal from "react-reveal/Reveal";
import { FiPlus } from "react-icons/fi";
import { useMediaQuery } from "react-responsive";

import { Logo } from "../Logo";
import { NavigationDesktop } from "../Header/Navigation/Desktop";
import { SocialIcons } from "../Header/SocialIcons";
import { Input } from "../Input";
import { BackToTop } from "./BackToTop";
import { Button } from "../Button";

import { Container } from "./styles";

export function Footer({ links, socialLinks }) {
  const isDesktop = useMediaQuery({ query: "(min-width: 1024px)" });
  const [subscribed, setSubscribed] = useState();

  const [emailAddress, setEmailAddress] = useState("");

  return (
    <Reveal>
      <Container desktop={isDesktop}>
        <Logo name="Periscope" size="small" />
        <div>
          <NavigationDesktop links={links} />
          <div style={{ margin: "0 3em 0 0" }}>
            <SocialIcons links={socialLinks} />
          </div>
          {subscribed ? (
            <div>
              <Button
                buttonStyle="invert-point"
                onClick={() => setSubscribed(false)}
              >
                Unsubscribe
              </Button>
            </div>
          ) : (
            <Input
              placeholder="Subscribe to our newsletter..."
              button={{
                label: <FiPlus size={30} />,
                color: "#0D97EA",
                buttonStyle: "invert-point",
              }}
              value={emailAddress}
              onChange={(e) => setEmailAddress(e.target.value)}
              inputStyle="pointy"
              size="small"
              inline={true}
              onSubmit={() => setSubscribed(true)}
            />
          )}
          <BackToTop desktop={isDesktop} />
        </div>
      </Container>
    </Reveal>
  );
}
